<template>
	<component :is="iconComponent" type="duotone" />
</template>

<script setup>
import { computed } from 'vue'
import { iconsByFileExt } from '@/helpers/constants'
import * as fileIcons from '@/icons/fileIcons'
import { getIconByFileExt } from '@/helpers/utils'

const props = defineProps({
	icon: { type: String, default: iconsByFileExt.generic },
	ext: String,
})
const iconName = computed(() => props.icon || getIconByFileExt(props.ext))
const iconComponent = computed(() =>
	iconName.value ? fileIcons[iconName.value] : null
)
</script>
